import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";

export function useClaims() {
  const { instance, accounts } = useMsal();
  const [email, setEmail] = useState<string | null>(null);
  const [groups, setGroups] = useState<string[]>([]);
  const [name, setName] = useState<string | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const account = instance.getActiveAccount() || accounts[0];
    if (!account) return;

    async function loadClaims() {
      try {
        const response = await instance.acquireTokenSilent({
          scopes: ["User.Read"], // 👈 pode ser o escopo que seu app já usa
          account,
          forceRefresh: true,    // 👈 garante que não pega token velho do cache
        });

        const claims: any = response.idTokenClaims || {};

        const mail =
          claims.email ||
          claims.preferred_username ||
          claims.upn ||
          null;

        setEmail(mail);
        setGroups(claims.groups || []);
        setName(claims.name || claims.preferred_username || null);
        setIsReady(true);
      } catch (err) {
        console.error("Erro ao carregar claims", err);
      }
    }

    loadClaims();
  }, [instance, accounts]);

  return { email, groups, isReady, name };
}
